import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import { SignUpService } from '@features/sign-up/services/sign-up.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [CommonModule],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [SignUpService],
    };
  }

  constructor() {
    const parentModule = inject(SharedModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error('SharedModule is already loaded. Import it in the CoreModule only');
    }
  }
}
